import React from "react"
import cx from "classnames"

import RenderBodyModule from "./RenderBodyModule"
import RenderSideModule from "./RenderSideModule"
import BlockList from "./BlockList"

import { isEmptyArray } from "../../utils"
import { PageLayoutModel } from "../../models/pages"

interface PageLayoutProps extends PageLayoutModel {
  hero?: React.ReactNode
  hasSidebar?: boolean
  fullWidth?: boolean
  pageContext: any
}

const defaultProps = {}

export const PageLayout: React.FC<PageLayoutProps> = props => {
  // console.log("PageLayout: ", props)
  const hasModularBlocks =
    !isEmptyArray(props.body) || !isEmptyArray(props.sidebar)

  const layoutClass = cx({
    hero: props.hero,
    "with-sidebar": props.hasSidebar,
  })

  return (
    <>
      {(props.hero || hasModularBlocks) && (
        <section className={layoutClass}>
          <div className="grid-container">
            <div className="grid-x grid-margin-x">
              <div className="cell large-auto">
                <div className={props.fullWidth ? "" : "page__body"}>
                  {props.hero}
                  {/* {props} */}
                  {props.body.map((modularBlock, index) => (
                    <RenderBodyModule
                      key={`modularBlock_${index}`}
                      block={modularBlock}
                      hasSidebar={props.hasSidebar}
                      pageContext={props.pageContext}
                    />
                  ))}
                </div>
              </div>

              {(props.hasSidebar || props.sidebar.length > 0) && (
                <div className="cell large-shrink">
                  <div className="page__sidebar">
                    {props.sidebar.map((modularBlock, index) => (
                      <RenderSideModule
                        key={`sideModule_${index}`}
                        block={modularBlock}
                        pageContext={props.pageContext}
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      )}

      <BlockList items={props.blocks} pageContext={props.pageContext} />
    </>
  )
}

PageLayout.defaultProps = defaultProps

export default PageLayout
